import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pc-icon" }
const _hoisted_2 = ["xlink:href"]

import { ref, onMounted } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SvgSprite',
  props: {
  name: String,
},
  setup(__props) {

const props = __props;

const spritePath = ref<string>("");

onMounted(async () => {
  try {
    spritePath.value = `${window.location.origin}/assets/svg/sprite.svg`;
    // console.log("SVG sprite path:", spritePath.value);
  } catch (error) {
    // console.error("Error loading SVG sprite:", error);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("use", {
      "xlink:href": `${spritePath.value}#${props.name}`
    }, null, 8, _hoisted_2)
  ]))
}
}

})